const list = {
  path: 'wechat',
  component: resolve => require(['@/pages/admin/aftersales/wechat'], resolve)
}

export default list
